import { notifications } from '@mantine/notifications';

type NotificationParams = {
  title?: string;
  message: string;
  autoClose?: number | boolean;
};

export const showSuccessNotification = ({
  title = 'Success',
  message,
  autoClose = 5000
}: NotificationParams) => {
  notifications.show({
    title,
    message,
    color: 'green',
    position: 'top-right',
    autoClose
  });
};

export const showErrorNotification = ({
  title = 'Error',
  message,
  autoClose = 5000
}: NotificationParams) => {
  notifications.show({
    title,
    message,
    color: 'red',
    position: 'top-right',
    autoClose
  });
};

export const showWarningNotification = ({
  title = 'Warning',
  message,
  autoClose = 7000
}: NotificationParams) => {
  notifications.show({
    title,
    message,
    color: 'yellow',
    position: 'top-right',
    autoClose
  });
};

export const showNotification = (params: NotificationParams & { type: 'success' | 'error' }) => {
  const { type, ...rest } = params;
  return type === 'success' ? showSuccessNotification(rest) : showErrorNotification(rest);
};
